<template>
  <div>
     <v-toolbar color="white" class="pt-3">
        <v-toolbar-title>
            <span class="headline secondary--text">
              {{$t('venue.label.update.title')}}
            </span>
           <span v-if="venue">/ {{ venue.name }}
             <v-chip
              v-if="venue"
              class="mx-2"
              small
              :color="venue.is_published ? 'secondary' : 'green'"
              outline
            >{{venue.is_published ? $t('venue.status.locked') : $t('venue.status.draft')}}</v-chip>
           </span>
        </v-toolbar-title>
      </v-toolbar>
        <v-card>
           <v-layout row wrap class="px-3 py-4">
            <v-flex xs4>
              <v-card-actions>
                <v-btn v-if="!showConfig" small icon @click="showConfig = true">
                  <v-icon  color="success">mdi-settings</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
            <v-flex xs4 md4>
              <div class="theater-screen ma-auto">
                <div class="screen-label subheading">{{$t('screener.screen.label')}}</div>
              </div>
            </v-flex>
             <v-flex xs4 md4>
              <SeatTypeLabels class="ml-4" :venue="venue" :selectedSeats="selectedSeats" ></SeatTypeLabels>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="pr-3 pl-1">
            <v-flex  xs12 v-show="showConfig" :md3="showConfig" >
              <VenueConfig @venueUpdated="getVenue()" @closeConfig="showConfig= false" :venue="venue"></VenueConfig>
            </v-flex>
            <v-flex class="pl-2" xs12 :md9="showConfig" :md12="!showConfig">
              <v-card class="blue lighten-5 pa-2" flat width="100%" height="100%" style="overflow:auto;">
                <VenueSeats
                :venue.sync="venue"
                @onSeatsUpdate="getVenue()"
                @onUpdateVenue="updateVenueLocally"
                @onSeatSelected="onSeatSelected"
                ></VenueSeats>
              </v-card>
            </v-flex>

          </v-layout>
        </v-card>
  </div>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapFields } from "vuex-map-fields";
import SeatTypeLabels from "@/components/seats/SeatTypeLabels";
import VenueSeats from "./VenueSeats";
import VenueConfig from "./VenueConfig.vue"

export default {
  name: "VenueUpdate",
  data() {
    return {
      rules,
      venue: null,
      showConfig: true,
      selectedSeats: []
    };
  },
  components: {
    VenueSeats,
    SeatTypeLabels,
    VenueConfig
  },
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getVenue();
    });
  },
  methods: {
    async getVenue() {
      await this.$store
        .dispatch("venue/get", {
          id: this.$route.params.venue_id,
        })
        .then((response) => {
          this.venue = response.venue;
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
    updateVenueLocally(venue) {
      this.venue = venue
    },
    onSeatSelected(selectedSeats){
      this.selectedSeats = selectedSeats
    }
  },
};
</script>
<style scoped>
.theater-screen {
  border-top: 4em solid rgba(0, 0, 0, 0.1);
  border-left: 3em solid transparent;
  border-right: 3em solid transparent;
  height: 0;
  width: 100%;
  text-align: center;
}
.screen-label{
    position: relative;
    top: -40px;
    color: rgba(0,0,0,0.6);
}

</style>
